"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const configs_1 = __importDefault(require("./configs"));
const Spinner_1 = __importDefault(require("../Spinner"));
const Button = (props) => {
    // const element = Children.only(props.children);
    const refRippler = (0, react_1.useRef)(null);
    function debounce(func, delay) {
        let inDebounce;
        return function () {
            const context = refRippler.current;
            const args = arguments;
            clearTimeout(inDebounce);
            inDebounce = setTimeout(() => func.apply(context, args), delay);
        };
    }
    function addRipple(e) {
        const ripple = refRippler.current;
        if (ripple) {
            const size = ripple.offsetWidth;
            const pos = ripple.getBoundingClientRect();
            const rippler = document.createElement("span");
            const x = e.clientX - (pos.left || 0) - size / 2;
            const y = e.clientY - (pos.top || 0) - size / 2;
            const style = "top:" +
                y +
                "px; left:" +
                x +
                "px; height: " +
                size +
                "px; width: " +
                size +
                "px;";
            ripple.querySelector(".ripple--container").appendChild(rippler);
            rippler.setAttribute("style", style);
        }
    }
    function cleanUp() {
        const ripple = refRippler.current;
        if (ripple) {
            var container = ripple.querySelector(".ripple--container");
            while (container.firstChild) {
                container.removeChild(container.firstChild);
            }
        }
    }
    (0, react_1.useEffect)(() => {
        const ripple = refRippler.current;
        if (ripple instanceof Object && props.ripple) {
            const rippleContainer = document.createElement("span");
            rippleContainer.className = "ripple--container";
            ripple && ripple.addEventListener("mousedown", (e) => addRipple(e));
            ripple && ripple.addEventListener("mouseup", debounce(cleanUp, 2000));
            if (ripple && !ripple.querySelector(".ripple--container")) {
                // ripple.rippleContainer = rippleContainer;
                ripple && ripple.appendChild(rippleContainer);
            }
        }
        return () => {
            if (props.ripple) {
                ripple && ripple.removeEventListener("mousedown", (e) => addRipple(e));
                ripple &&
                    ripple.removeEventListener("mouseup", debounce(cleanUp, 2000));
            }
        };
    }, [props.ripple]);
    const className = [
        "btn rounded font-heading relative appearance-none focus:outline-none transition-colors duration-300 inline-flex items-center select-none overflow-hidden",
        configs_1.default?.size?.[props.size] || "",
        configs_1.default?.state?.[props.isDisabled ? "disabled" : props.state] || "",
        props.className || "",
    ];
    //   hover:bg-blue-800 flex items-center justify-center h-10 w-10 rounded-full mb-2
    if (props.state === "tertiary" && !props.isDisabled && !props.isLoading)
        className.push(configs_1.default?.color?.[props.color || "success"] || "");
    let children = props.children;
    let onClick = props.children.props.onClick;
    if (props.isDisabled || props.isLoading) {
        onClick = (event) => {
            event.preventDefault && event.preventDefault();
        };
        // children = <span>{props.children.props.children}</span>;
    }
    const childrenReturn = react_1.default.cloneElement(children, {
        ...props.children.props,
        onClick,
        disabled: props.isDisabled || props.isLoading,
        children: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { className: [
                        "transition-all duration-300 inline-flex items-center",
                        props.isLoading
                            ? "-top-full opacity-0 invisible"
                            : "top-0 opacity-100 visible",
                    ].join(" "), children: props.children.props.children }), (0, jsx_runtime_1.jsx)("span", { className: [
                        "transition-all duration-300 absolute left-0 right-0 bottom-0 z-10 inline-flex items-center justify-center ",
                        props.isLoading ? "top-0 opacity-100" : "-top-full opacity-0",
                    ].join(" "), children: (0, jsx_runtime_1.jsx)(Spinner_1.default, {}) })] })),
    });
    return react_1.default.cloneElement(childrenReturn, {
        className: className.join(" "),
        ripple: JSON.stringify(props.ripple),
        ref: refRippler,
    });
};
Button.defaultProps = {
    className: "",
    size: "md",
    state: "primary",
    color: "link",
};
exports.default = Button;
